/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptDto } from '../../models/receipt-dto';

export interface ReceiptControllerFindByEnrollmentScheduleId$Params {
  enrollmentScheduleId: string;
}

export function receiptControllerFindByEnrollmentScheduleId(http: HttpClient, rootUrl: string, params: ReceiptControllerFindByEnrollmentScheduleId$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerFindByEnrollmentScheduleId.PATH, 'get');
  if (params) {
    rb.query('enrollmentScheduleId', params.enrollmentScheduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptDto>;
    })
  );
}

receiptControllerFindByEnrollmentScheduleId.PATH = '/api/receipt/enrollment-schedule';
